import React from 'react';
import {StyledLink, StyledButton} from './styles';

function Button({to, type, onClick, children, disabled}) {
  if (to) {
    return <StyledLink to={to} disabled={disabled}>{children}</StyledLink>;
  }
  
  return <StyledButton type={type} onClick={onClick} disabled={disabled}>{children}</StyledButton>;
}

export default Button;